var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[(!_vm.$route.meta.public)?_c('layout-principal'):[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }